/**
 * Shared internals for the `hooks/chat/*` primitives.
 *
 * Lives outside the individual hooks because both
 * `useActiveConversation` and `useSendMessage` need to read/write the
 * same React Query cache key and would otherwise have to import each
 * other.
 */

export const ACTIVE_CONVERSATION_QUERY_KEY = "active_conversation";

// Stable client-side message IDs so the React Query cache can identify
// the in-flight assistant placeholder by name rather than by position
// in the messages array. Solves two bugs: (1) memoised renderers no
// longer miss in-place mutations because each refreshCache produces a
// new message reference; (2) two concurrent runs can't accidentally
// write into each other's placeholder because the lookup is keyed.
let _localMessageCounter = 0;
export const newClientMessageId = () => {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return `cm_${Date.now()}_${++_localMessageCounter}`;
};

export const createEmptyConversation = () => ({
  messages: [
    {
      role: "assistant",
      content:
        "Hi! 👋 I'm Savills Knowledge Cubed Portfolio Assistant. My job is to answer questions about your real estate lease portfolio and related market data. How can I help you today?",
      feedbackType: null,
      comment: "",
    },
  ],
  networkErrorActive: false,
});
